import HttpClient from "../../utils/http";
import { notification_endpoint } from "../constants/api_endpoints";

export const addNotification = async (payload: FormData) => {

    return HttpClient.post(notification_endpoint, payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

}
export interface NotificationFilters {
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
  module?: string;
  status?: string;
  isScheduled?: boolean;
  sortOrder?: "ASC" | "DESC";
  orgId?: number | null;
}

export const getNotifications = async (filters: NotificationFilters) => {
  const { page, pageSize, startDate, endDate, module, status, isScheduled, sortOrder, orgId } = filters;

  const params = new URLSearchParams({
    page: page.toString(),
    size: pageSize.toString(),
  });

  if (startDate) params.append("dateFrom", startDate);
  if (endDate) params.append("dateTo", endDate);
  if (module) params.append("module", module);
  if (status) params.append("status", status);
  if (isScheduled !== undefined) params.append("is_scheduled", isScheduled.toString());
  if (sortOrder) params.append("sortOrder", sortOrder);
  if (orgId) params.append("orgId", orgId.toString());

  const url = `${notification_endpoint}?${params.toString()}`;
  return HttpClient.get(url);
};

export interface SignedUrlRequest {
  fileName: string;
  bucketType: string;
  contentType: string;
  ObjectId: string;
}

export interface SignedUrlResponse {
  signedUrl?: string;
  url?: string;
  data?: {
    signedUrl?: string;
    url?: string;
  };
}

export const getSignedUrl = async (payload: SignedUrlRequest): Promise<any> => {
  return HttpClient.post("v1/admin/qsubscribers/signed-url", payload);
};

export interface TTSRequest {
  text: string;
  language: string;
}

export interface TTSResponse {
  audio?: string; // Base64 encoded audio
  data_url?: string; // Data URL format: "data:audio/wav;base64,..."
  format?: string; // Audio format (e.g., "wav", "mp3")
  language?: string; // Language code
  audioUrl?: string; // Legacy support
  data?: {
    audioUrl?: string;
    audio?: string;
    data_url?: string;
    format?: string;
  };
}

export const convertTextToSpeech = async (payload: TTSRequest): Promise<any> => {
  // Use direct fetch for localhost TTS service
  const response = await fetch("http://localhost:5001/tts/generate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`TTS API error: ${response.statusText} - ${errorText}`);
  }
  
  // Check if response is binary audio (audio/mpeg, audio/wav, etc.)
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.startsWith("audio/")) {
    return response.blob();
  }
  
  // Otherwise, try to parse as JSON
  try {
    return await response.json();
  } catch (e) {
    // If JSON parsing fails, return as blob
    return response.blob();
  }
};
